module.exports = __webpack_public_path__ + "static/media/Roboto-Italic.93b13a58.ttf";